import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import BotonVolver from './BotonVolver';
import LogoRG from '../assets/images/logo-bordes.png'

export default function TiqueteraLanding() {
  const navigate = useNavigate();
  const [t, i18n] = useTranslation("global");

  const handleContact = () => {
    navigate('/'); // Navega a la ruta principal
    setTimeout(() => {
      const contactElement = document.getElementById('contacto');
      if (contactElement) {
        contactElement.scrollIntoView({ behavior: 'smooth' });
      }
    }, 500);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#06061e] via-black to-[#08083a]">
      {/* Back Button */}
      <BotonVolver text={t("tiquetera.volver")} />

      <main className="container mx-auto px-4 pt-16">
        {/* Hero Section */}
        <section className="pt-16 pb-16 text-center flex flex-col items-center justify-center">
          <img src={LogoRG} alt="RG Entradas Logo" className="w-64 h-auto mb-8" />
          <h1 className="text-5xl md:text-6xl font-messina tracking-wide text-white mb-4">
            {t("tiquetera.title")}
          </h1>
          <p className="text-xl text-gray-300 font-neolatina mb-8 max-w-3xl mx-auto">
            {t("tiquetera.texto-2")}
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <a
              href="https://rgentradas.com"
              target="_blank"
              rel="noopener noreferrer"
              className="px-8 py-3 text-lg border-2 border-[#0dc1ba] text-[#0dc1ba] hover:bg-[#0dc1ba] hover:text-[#08083a] rounded-lg transition-all duration-300 font-semibold flex items-center justify-center w-full sm:w-auto"
            >
              {t("tiquetera.visit-btn")}
            </a>
            <button
              onClick={() => document.getElementById('contacto-tiquetera')?.scrollIntoView({ behavior: 'smooth' })}
              className="px-8 py-3 text-lg bg-white text-black hover:bg-gray-200 rounded-lg transition-colors w-full sm:w-auto font-semibold"
            >
              {t("tiquetera.texto-8")}
            </button>
          </div>
        </section>

        {/* Features Section */}
        <section className="py-16">
          <div className="bg-zinc-800/70 backdrop-blur rounded-lg p-8 shadow-lg">
            <h2 className="text-4xl font-messina tracking-wide text-white mb-8 text-center">
              {t("tiquetera.texto-9")}
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {[
                {
                  title: t("tiquetera.title-4"),
                  description: t("tiquetera.descripcion-4")
                },
                {
                  title: t("tiquetera.title-5"),
                  description: t("tiquetera.descripcion-5")
                },
                {
                  title: t("tiquetera.title-6"),
                  description: t("tiquetera.descripcion-6")
                },
                {
                  title: t("tiquetera.title-7"),
                  description: t("tiquetera.descripcion-7")
                },
                {
                  title: t("tiquetera.title-8"),
                  description: t("tiquetera.descripcion-8")
                },
                {
                  title: t("tiquetera.title-9"),
                  description: t("tiquetera.descripcion-9")
                }
              ].map((feature, index) => (
                <div key={index} className="bg-zinc-900/50 p-6 rounded-lg space-y-3 hover:bg-zinc-700/50 transition-colors">
                  <h3 className="text-2xl font-semibold text-white">{feature.title}</h3>
                  <p className="text-gray-300">{feature.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Stats Section */}
        <section className="py-16 grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="flex flex-col justify-center items-center bg-zinc-900/50 backdrop-blur rounded-lg p-8">
            <div className="text-5xl font-bold text-white mb-2">5000+</div>
            <div className="text-gray-400">{t("tiquetera.texto-4")}</div>
          </div>
          <div className="flex flex-col justify-center items-center  bg-zinc-900/50 backdrop-blur rounded-lg p-8">
            <div className="text-5xl font-bold text-white mb-2">12+</div>
            <div className="text-gray-400">{t("tiquetera.texto-5")}</div>
          </div>
        </section>

        {/* CTA / Contact Section */}
        <section id="contacto-tiquetera" className="py-16 text-center">
          <div className="bg-zinc-900/50 backdrop-blur border border-zinc-800 rounded-lg p-10 max-w-4xl mx-auto">
            <h2 className="text-4xl font-messina tracking-wide text-white mb-4">
              {t("tiquetera.texto-6")}
            </h2>
            <p className="text-xl font-neolatina text-gray-300 mb-10">
              {t("tiquetera.texto-7")}
            </p>

            <div className="flex flex-col md:flex-row gap-6 justify-center items-center">
              {/* WhatsApp Button */}
              <a
                href="https://wa.me/5492216914649"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-3 px-6 py-3 bg-[#25D366] hover:bg-[#20ba5a] text-white rounded-xl transition-all duration-300 transform hover:scale-105 w-full md:w-auto font-semibold text-md shadow-lg shadow-[#25D366]/20"
              >
                <svg className="w-6 h-6 fill-current" viewBox="0 0 24 24">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.67-1.614-.917-2.214-.242-.584-.488-.504-.67-.513-.173-.008-.371-.009-.57-.009-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
                </svg>
                {t("tiquetera.whatsapp")}
              </a>

              {/* Email Button */}
              <a
                href="mailto:contacto@rgentradas.com"
                className="flex items-center justify-center gap-3 px-6 py-3 bg-zinc-100 hover:bg-white text-black rounded-xl transition-all duration-300 transform hover:scale-105 w-full md:w-auto font-semibold text-md shadow-lg"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                {t("tiquetera.email")}
              </a>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}